import { FC } from 'react'
import intro from 'Assets/upload/images/intro.png'
import intro2x from 'Assets/upload/images/intro@2x.png'

interface Props {
  clientName: string
}

const HomeSection: FC<Props> = ({ clientName }) => (
  <section className="section section_green home__section section_big-padding">
    <div className="intro">
      <div className="container">
        <div className="h1 h1 intro__title" id="clientName">
          {clientName},<br />
          это доставка Welcome Group.
        </div>
        <p>
          На&nbsp;этой странице вы&nbsp;можете отследить статус заказа, оценить
          нашу работу и&nbsp;прочее.
        </p>
        <p>Приятного аппетита!</p>
        <img className="intro__img" src={intro} srcSet={intro2x} alt={''} />
      </div>
    </div>
  </section>
)

export default HomeSection
